// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
  margin: 0;
  padding: 0 120px;
  font-family: 'Arial', sans-serif,"Inter", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue";
  background-color: #f4f4f4;
}

.container {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}

.section {
  margin-bottom: 30px;
}

@media (max-width: 1024px) {
  body, html {
    padding: 0 20px;
  }
  .container {
    width: auto; /* Allows container to grow with the screen size, up to its max-width */
    padding: 20px; /* Maintain internal padding */
    margin: 20px; /* Add margin to maintain visual separation from screen edges */
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,gBAAgB;EAChB,4IAA4I;EAC5I,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,WAAW,EAAE,uEAAuE;IACpF,aAAa,EAAE,8BAA8B;IAC7C,YAAY,EAAE,+DAA+D;EAC/E;AACF","sourcesContent":["body, html {\n  margin: 0;\n  padding: 0 120px;\n  font-family: 'Arial', sans-serif,\"Inter\", \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\";\n  background-color: #f4f4f4;\n}\n\n.container {\n  max-width: 800px;\n  margin: 20px auto;\n  padding: 20px;\n  background: #fff;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n}\n\n.section {\n  margin-bottom: 30px;\n}\n\n@media (max-width: 1024px) {\n  body, html {\n    padding: 0 20px;\n  }\n  .container {\n    width: auto; /* Allows container to grow with the screen size, up to its max-width */\n    padding: 20px; /* Maintain internal padding */\n    margin: 20px; /* Add margin to maintain visual separation from screen edges */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
